import { useState, useEffect, type ReactNode, type FormEvent } from 'react'
import type { Session } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'

// Gates the dashboard behind a Supabase Auth session. The anon key alone can
// no longer read jgl_* tables (RLS denies anon by default) — data access
// requires an authenticated session, on top of the Cloudflare Access gate
// already protecting jglcap.l7-partners.com at the edge.
export function AuthGate({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null)
  const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [signingIn, setSigningIn] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session)
      setLoading(false)
    })
    const { data: listener } = supabase.auth.onAuthStateChange((_event, newSession) => {
      setSession(newSession)
    })
    return () => listener.subscription.unsubscribe()
  }, [])

  const handleSignIn = async (e: FormEvent) => {
    e.preventDefault()
    setSigningIn(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setSigningIn(false)
  }

  if (loading) return null

  if (!session) {
    return (
      <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', fontFamily: 'system-ui, sans-serif' }}>
        <form onSubmit={handleSignIn} style={{ display: 'flex', flexDirection: 'column', gap: 12, width: 320, padding: 32, border: '1px solid #333', borderRadius: 8 }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>JGL Capital Dashboard</h2>
          {error && <div style={{ color: '#e5484d', fontSize: 13 }}>{error}</div>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            style={{ padding: 8, borderRadius: 4, border: '1px solid #444', background: 'transparent', color: 'inherit' }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ padding: 8, borderRadius: 4, border: '1px solid #444', background: 'transparent', color: 'inherit' }}
          />
          <button type="submit" disabled={signingIn} style={{ padding: 10, borderRadius: 4, border: 'none', background: '#2563eb', color: '#fff', cursor: 'pointer' }}>
            {signingIn ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    )
  }

  return <>{children}</>
}
